import React from 'react'
import "../../Page_styles/LandingPage/Terms.css"
const Terms = () => {
  return (
    <>
    <section className="terms-section">
      <div className="terms-container">

        <div className="terms-title">
          <h1>Terms and Conditions</h1>
        </div>

      </div>
    </section>
    <section className="terms-section">
      <div className="terms-container">

        <div className="terms-card">

          <h2>Welcome to <span>SocialFly</span>.</h2>

          <p>
            These Terms and Conditions ("Terms") govern your access to and use
            of our business management software services.
          </p>

          <p>
            By creating an account or using our services, you agree to be bound
            by these Terms. If you do not agree, please do not use our platform.
          </p>

          <h2>Services and Account Security</h2>

          <p>
            SocialFly provides cloud-based business management tools.
          </p>

          <ul>
            <li>
              <strong>Eligibility :</strong> You must be at least 18 years old or
              the legal age of majority in your jurisdiction.
            </li>

            <li>
              <strong>Account Responsibility :</strong> You are responsible for
              maintaining your login credentials and all activity under your
              account.
            </li>
          </ul>

          <h2>Data Management & Permanent Deletion</h2>

          <p>
            SocialFly prioritizes user privacy and system efficiency.
          </p>

          <ul>
            <li>
              <strong>No Recovery :</strong> Deleted data is permanently removed.
            </li>

            <li>
              <strong>Storage Optimization :</strong> We do not maintain archived
              backups of deleted data.
            </li>

            <li>
              <strong>User Backups :</strong> Export important data before
              deletion.
            </li>
          </ul>

          <h2>Prohibited Use</h2>

          <p>You agree not to :</p>

          <ul>
            <li>Use the service for illegal purposes.</li>
            <li>Attempt to hack or reverse engineer the software.</li>
            <li>Spread malware, spam or offensive content.</li>
          </ul>

          <h2>Payments, Subscriptions and Fees</h2>

          <p>
            Paid subscriptions may be required for certain premium features.
          </p>

          <ul>
            <li>
              <strong>Billing :</strong> Fees are charged according to your
              selected plan.
            </li>

            <li>
              <strong>Auto Renewal :</strong> Subscriptions renew automatically
              unless cancelled.
            </li>
          </ul>

          <h2>Refund Policy</h2>

          <p>
            We want you to be satisfied with SocialFly while maintaining fair
            operational standards.
          </p>

          <ul>
            <li>Free trials are available where applicable.</li>
            <li>Refunds are generally not provided after billing.</li>
            <li>Exceptions may apply for verified technical issues.</li>
            <li>Subscriptions may be cancelled anytime.</li>
          </ul>
          <h2>Affiliate Program Terms</h2>

<p>
  The AssetPegasus Affiliate Program allows approved affiliates to earn
  commissions by referring new paying customers through their assigned
  referral link or code. Participation is subject to approval and
  compliance with these Terms.
</p>

<h3>Commission Rates</h3>

<p>
  Eligible referrals earn commission based on the subscription plan
  purchased by the referred customer:
</p>

<ul>
  <li>
    <strong>Base Plan:</strong> 10% commission.
  </li>

  <li>
    <strong>Grow Plan:</strong> 15% commission.
  </li>

  <li>
    <strong>Omni Plan:</strong> 20% commission.
  </li>
</ul>

<p>
  Commission is calculated on the subscription amount actually received
  after discounts, excluding taxes, refunds, and chargebacks. Free trials,
  unpaid subscriptions, and unsuccessful transactions do not qualify
  for commission.
</p>

<h3>Referral Eligibility and Verification</h3>

<ul>
  <li>
    Referrals must be tracked through the affiliate’s assigned referral
    link or code and verified by AssetPegasus.
  </li>

  <li>
    Commission becomes eligible for approval only after the referred
    customer’s payment has been successfully received and verified.
  </li>

  <li>
    Self-referrals, duplicate accounts, fraudulent transactions, and
    referrals created to misuse the program are not eligible.
  </li>

  <li>
    Eligibility for commissions on renewals, upgrades, and subsequent
    purchases will be specified in the affiliate’s program offer.
    Recurring commissions should not be assumed unless expressly
    included.
  </li>
</ul>

<h3>Manual Payments and Processing Time</h3>

<p>
  Affiliate payouts are processed manually outside the platform’s
  automated subscription checkout. Payments are made through an agreed
  payment method, such as bank transfer or UPI, using the details
  provided by the affiliate.
</p>

<ul>
  <li>
    <strong>Processing Time:</strong> Approved payouts are normally
    processed within 3–4 working days after payout approval and
    verification of complete payment details.
  </li>

  <li>
    <strong>Working Days:</strong> Working days exclude Saturdays,
    Sundays, and public holidays observed by the processing bank
    in India.
  </li>

  <li>
    <strong>Payment Details:</strong> Affiliates must provide accurate
    and current payment information. Incorrect or incomplete details
    may delay payment.
  </li>

  <li>
    <strong>Bank Delays:</strong> The time taken for funds to reach
    the affiliate’s account may vary due to bank or payment-provider
    processing.
  </li>

  <li>
    <strong>Payment Confirmation:</strong> A transaction reference or
    payment confirmation will be provided once the transfer is
    completed.
  </li>
</ul>

<h3>Refunds, Cancellations and Adjustments</h3>

<p>
  Commissions associated with refunded, reversed, disputed, or fraudulent
  payments may be withheld or reversed. If the corresponding commission
  has already been paid, the adjustment may be deducted from future
  affiliate earnings, with the reason communicated to the affiliate.
  Subscription cancellation alone does not reverse a commission on a
  valid payment that has not been refunded.
</p>

<h3>Affiliate Responsibilities</h3>

<ul>
  <li>
    Promote AssetPegasus honestly using accurate information about
    its features, pricing, and subscription plans.
  </li>

  <li>
    Clearly disclose the affiliate relationship when sharing
    promotional content or referral links.
  </li>

  <li>
    Do not use spam, misleading claims, impersonation, unauthorized
    discounts, or deceptive advertising to obtain referrals.
  </li>

  <li>
    Do not collect customer payments on behalf of AssetPegasus or
    make commitments on its behalf without written authorization.
  </li>

  <li>
    Affiliates are responsible for their applicable tax obligations.
    Payouts may be subject to deductions or withholding where
    required by applicable law.
  </li>
</ul>

<h3>Suspension, Termination and Program Changes</h3>

<p>
  AssetPegasus may suspend or terminate participation for fraud,
  misuse, or violations of these Terms. Valid commissions earned
  before termination remain payable, subject to verification and
  any applicable adjustments.
</p>

<p>
  Changes to commission rates or payout terms will be communicated
  before taking effect. Updated terms apply prospectively and do
  not reduce commissions already earned under the previously
  applicable terms.
</p>

<p>
  For questions about referrals, commission calculations, or payout
  status, contact{" "}
  <a href="mailto:support@assetpegasus.com">
    support@assetpegasus.com
  </a>.
</p>
          <h2>Limitation of Liability</h2>

          <p>
            To the maximum extent permitted by law, SocialFly shall not be
            liable for:
          </p>

          <ul>
            <li>Indirect or consequential damages.</li>
            <li>Loss of profits, revenue or business data.</li>
            <li>Unauthorized access due to insecure credentials.</li>
          </ul>

          <p className="highlight">
            Our service is provided on an <strong>"As Is"</strong> and
            <strong> "As Available"</strong> basis.
          </p>

          <h2>Global Governing Law</h2>

          <p>
            These Terms shall be governed by the laws of West Bengal, India.
          </p>

          <h2>Modifications to Terms</h2>

          <p>
            We reserve the right to update these Terms at any time. Continued
            use of the platform constitutes acceptance of the revised Terms.
          </p>

        </div>
      </div>
    </section>
    <section className="contactInfo">
      <div className="contactInfo-container">

        <button className="privacy-btn">
          Privacy Policy
        </button>

        <h2>Contact Information</h2>

        <p className="contact-desc">
          For questions regarding these Terms or to request a refund evaluation,
          please contact us at:
        </p>

        <button className="contact-btn">
          Contact Us
        </button>

        <div className="contact-details">

          <ul>
            <li>
              <strong>Support Email :</strong>
              <span> support@assetpegasus.com</span>
            </li>

            <li>
              <strong>Mailing Address :</strong>
              <span> info@assetpegasus.com</span>
            </li>
          </ul>

        </div>

      </div>
    </section>
    </>
  )
}

export default Terms;